import { JSX } from 'react';
import DashboardTile from '@app/shared/qes-standards/DashboardTile';
import { MembershipMap } from '@app/overviews/market-expansion-dashboard/components/membership-map/MembershipMap';

const MembershipTile = (): JSX.Element => {
  
  return (
    <DashboardTile title={"Market Opportunity"} widthClass="col-12" classNames="px-2">
      <MembershipMap />
    </DashboardTile>
  );
}

export default MembershipTile;